import { render, staticRenderFns } from "./HoraLimite.vue?vue&type=template&id=221262ce"
import script from "./HoraLimite.vue?vue&type=script&lang=js"
export * from "./HoraLimite.vue?vue&type=script&lang=js"
import style0 from "./HoraLimite.vue?vue&type=style&index=0&id=221262ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports